import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { formsService } from '../api/forms.service';
import { SUBMISSION_KEYS } from './queryKeys';
import type { CreateTaskFromSubmissionPayload } from '../types';

export function useCreateTaskFromSubmission(formId: string, submissionId: string) {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: (data: CreateTaskFromSubmissionPayload) =>
      formsService.createTaskFromSubmission(formId, submissionId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: SUBMISSION_KEYS.detail(orgId ?? '', formId, submissionId),
      });
    },
  });
}
